/** Semantic HR full product tour: content from semantichr_main.mp4 (~43s). */

export const SEMHR_CHAT_HISTORY = [
  { title: 'What were headcount, hires, termi…', date: 'Jun 24, 6:22 AM', active: true },
  { title: 'Show active headcount by busines…', date: 'Jun 17' },
  { title: 'Which business units are growing o…', date: 'Jun 17' },
  { title: 'How many candidates are in each a…', date: 'Jun 17' },
];

export const SEMHR_SUGGESTED = [
  { tag: 'HEADCOUNT', q: 'What is active headcount by business unit as of today?' },
  { tag: 'ATTRITION', q: 'Show voluntary attrition rate by business unit for the last 12 months.' },
  { tag: 'HIRING', q: 'How many open requisitions do we have by department?' },
  { tag: 'PLANNING', q: 'Compare planned vs actual headcount for this fiscal year.' },
];

export const SEMHR_BOOKMARKS = [
  { id: 'headcount', label: 'HEADCOUNT', page: 'Headcount' },
  { id: 'terminations', label: 'TERMINATIONS & ATTRITION', page: 'Dashboard' },
  { id: 'hires', label: 'HIRES', page: 'Hires' },
  { id: 'recruiting', label: 'RECRUITING', page: 'Recruiting' },
  { id: 'candidates', label: 'CANDIDATES', page: 'Candidates' },
  { id: 'applications', label: 'APPLICATIONS', page: 'Applications' },
];

export const SEMHR_TOUR = {
  analyzingText: 'Analyzing your question…',
  question:
    'What were headcount, hires, terminations, and open requisitions by month for the full calendar year 2025?',
  intro:
    "Perfect! Here's the workforce data for calendar year 2025 by month: The data shows steady growth in active headcount throughout 2025, starting at 20,631 in January and growing to 21,305 by December, an increase of 674 employees (3.3%) over the year.",
  observations: [
    { lead: 'Hires', body: 'Monthly new hires ranged from 198 to 236, with an average of ~215 hires per month' },
    { lead: 'Terminations', body: 'Monthly terminations ranged from 119 to 188, with the highest turnover in November and December (likely year-end separations)' },
    { lead: 'Open Requisitions', body: 'Open headcount ranged from 1,552 to 1,683 positions, indicating consistent hiring pipeline activity with peak openings in December (1,683)' },
    { lead: 'Net Growth', body: 'The positive difference between hires and terminations each month drove the overall headcount growth, with months like January (+65 net), February (+88 net), and March (+91 net) showing the strongest growth in the first half of the year' },
  ],
  chart: {
    title: 'Hires Vs Terminations By Month',
    months: ["Jan'25", "Feb'25", "Mar'25", "Apr'25", "May'25", "Jun'25", "Jul'25", "Aug'25", "Sep'25", "Oct'25", "Nov'25", "Dec'25"],
    hires: [215, 228, 236, 205, 198, 214, 221, 241, 219, 205, 198, 214],
    terms: [150, 163, 145, 171, 163, 188, 160, 172, 158, 171, 188, 188],
  },
  table: {
    title: 'Workforce Summary by Month, 2025',
    columns: ['Month', 'Headcount', 'Hires', 'Terminations', 'Open Requisitions'],
    rows: [
      ["Jan'25", '20,631', '215', '150', '1,552'],
      ["Feb'25", '20,696', '228', '163', '1,578'],
      ["Mar'25", '20,784', '236', '145', '1,601'],
      ["Apr'25", '20,818', '205', '171', '1,612'],
      ["May'25", '20,853', '198', '163', '1,625'],
      ["Jun'25", '20,904', '214', '188', '1,633'],
      ["Jul'25", '20,965', '221', '160', '1,648'],
      ["Aug'25", '21,034', '241', '172', '1,661'],
    ],
    footer: 'Show 4 more',
  },
  followUps: [
    'How does this workforce summary compare to 2024 by month?',
    'Can you break down the 2025 headcount trend by business unit or company?',
    'What were the top termination reasons in 2025?',
  ],
  meta: {
    status: 'SUCCESS · 12 rows · 38.3s',
    agent: 'AI_ML.SEMANTIC_MODELS.SEMANTIC_HR_COPILOT_ANALYST',
    agentLabel: 'SemanticHR Copilot Analyst',
    model: 'AI_ML.SEMANTIC_MODELS.SF_HR_SEMANTIC_MODEL',
    queryId: '01c53592-3204-225e-0007-dac200518606',
  },
  reasoning: ['reviewed context and retrieved data', '1 generated query', 'reviewed data', 'created 1 chart'],
  sqlPreview: `WITH __headcount_monthly AS (
  SELECT DATE_TRUNC('month', effective_date) AS month,
    COUNT(DISTINCT employee_id) AS headcount
  FROM HR_SUCCESSFACTORS_DEV.REPORTING.VW_SF_HEADCOUNT_MONTHLY
  WHERE calendar_year = 2025 GROUP BY 1
), __hires AS (
  SELECT month, COUNT(*) AS hires
  FROM HR_SUCCESSFACTORS_DEV.REPORTING.VW_SF_HIRES
  WHERE calendar_year = 2025 GROUP BY 1
), __terminations AS (
  SELECT month, COUNT(*) AS terminations
  FROM HR_SUCCESSFACTORS_DEV.REPORTING.VW_SF_TERMINATIONS
  WHERE calendar_year = 2025 GROUP BY 1
)
SELECT h.month, h.headcount, hi.hires, t.terminations
FROM __headcount_monthly h
JOIN __hires hi ON h.month = hi.month
JOIN __terminations t ON h.month = t.month
ORDER BY h.month`,
  dynamicPlaceholder: 'New visualization, e.g. headcount by business unit as a bar chart',
  dynamicPrompt:
    'Which business units had the highest voluntary attrition rate by month for the full calendar year 2025?',
  editPlaceholder: 'Edit, e.g. grouped bars for Q1 2025, switch to horizontal bar',
  editPrompt: 'Switch to a line chart by month for the full calendar year 2025.',
  editSuggestions: [
    'Grouped bars for Q1 2025 only',
    'Switch to horizontal bar, sort highest first',
    'Overlay open requisitions on the chart',
  ],
  dynamicSuggestions: ['Headcount by business unit', 'Hires vs terminations', 'Attrition trend'],
  dashboards: {
    termination: {
      title: 'Termination Summary Dashboard',
      subtitle: 'Employee exits, attrition trends, and turnover drivers',
      bookmark: 'Dashboard',
      kpis: [
        { label: 'Total Terminations', value: '17,271', unit: 'employees', delta: '+8.3%', up: true },
        { label: 'Voluntary Rate', value: '65.1%', delta: '+2.1%', up: true },
        { label: 'Involuntary', value: '6,020', unit: 'employees', delta: '-4.2%', up: false },
        { label: 'Turnover Rate', value: '4.8%', delta: '+0.3%', up: true },
      ],
      reasonBars: [
        { label: 'Resignation', value: 1124, color: '#1e4d8c' },
        { label: 'Contract End', value: 682, color: '#2563eb' },
        { label: 'Illness', value: 418, color: '#3b82f6' },
        { label: 'Performance', value: 312, color: '#60a5fa' },
        { label: 'Misconduct', value: 228, color: '#7dd3fc' },
        { label: 'Retirement', value: 156, color: '#bae6fd' },
      ],
      deptBars: [
        { label: 'Engineering', value: 420, color: '#1e4d8c' },
        { label: 'Operations', value: 368, color: '#2563eb' },
        { label: 'Sales', value: 312, color: '#3b82f6' },
        { label: 'Finance', value: 248, color: '#4f8fd9' },
        { label: 'HR', value: 198, color: '#60a5fa' },
        { label: 'Marketing', value: 172, color: '#7eb8f7' },
        { label: 'IT', value: 148, color: '#93c5fd' },
        { label: 'Legal', value: 112, color: '#a5c9fa' },
      ],
      quarterly: [
        { label: "Q1'23", voluntary: 820, involuntary: 340 },
        { label: "Q2'23", voluntary: 860, involuntary: 355 },
        { label: "Q3'23", voluntary: 840, involuntary: 330 },
        { label: "Q4'23", voluntary: 910, involuntary: 380 },
        { label: "Q1'24", voluntary: 880, involuntary: 360 },
        { label: "Q2'24", voluntary: 920, involuntary: 370 },
        { label: "Q3'24", voluntary: 895, involuntary: 345 },
        { label: "Q4'24", voluntary: 940, involuntary: 390 },
      ],
    },
    headcount: {
      title: 'Headcount Summary Dashboard',
      subtitle: 'Headcount, hires, exits, and workforce movement',
      bookmark: 'Headcount',
      kpis: [
        { label: 'Active Headcount', value: '19,983', unit: 'employees' },
        { label: 'Planned Headcount', value: '22,832', unit: 'positions' },
        { label: 'Gap to Planned', value: '2,849', unit: 'positions' },
        { label: 'Open Requisitions', value: '730', unit: 'requisitions' },
      ],
      deptBars: [
        { label: 'Cloud Services', value: 2127, color: '#1e4d8c', highlight: true },
        { label: 'Enterprise Apps', value: 1984, color: '#2563eb' },
        { label: 'R&D Programs', value: 1762, color: '#3b82f6' },
        { label: 'Accounting', value: 1548, color: '#4f8fd9' },
        { label: 'Supply Chain', value: 1420, color: '#60a5fa' },
        { label: 'IT & Security', value: 1288, color: '#7eb8f7' },
        { label: 'Sales', value: 1156, color: '#93c5fd' },
      ],
      planLine: {
        months: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        active: [19240, 19380, 19520, 19680, 19780, 19860, 19920, 19950, 19970, 19980, 19983, 19983],
        planned: [19800, 19920, 20040, 20160, 20280, 20400, 20520, 20640, 20760, 20880, 21000, 21120],
      },
      table: {
        columns: ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        rows: [
          ['Active Headcount', '19,420', '19,510', '19,620', '19,710', '19,830', '19,983'],
          ['Planned Headcount', '19,800', '19,900', '20,000', '20,100', '20,200', '20,300'],
          ['Gap To Plan', '380', '390', '380', '390', '370', '317'],
          ['Openings', '712', '718', '725', '728', '730', '730'],
          ['Openings Filled', '215', '228', '236', '205', '198', '214'],
        ],
      },
    },
    hires: {
      title: 'Hire Summary Dashboard',
      subtitle: 'Hires, time-to-fill, and recruiting performance',
      bookmark: 'Hires',
      kpis: [
        { label: 'Total Hires', value: '38,253', delta: '+4%', up: true },
        { label: 'YTD 2025', value: '2,732', delta: '+4%', up: true },
        { label: 'Avg Time-to-Fill', value: '42 days', delta: '-3 days', up: false },
        { label: 'Accept Rate', value: '87%', delta: '+2%', up: true },
      ],
      yoyGroups: [
        { label: 'Corp Shared', y2024: 420, y2025: 480 },
        { label: 'Cloud Svcs', y2024: 380, y2025: 450 },
        { label: 'Finance', y2024: 290, y2025: 310 },
        { label: 'Supply Chain', y2024: 260, y2025: 280 },
        { label: 'IT & Security', y2024: 220, y2025: 240 },
        { label: 'R&D', y2024: 180, y2025: 200 },
        { label: 'Sales', y2024: 150, y2025: 170 },
      ],
      planLine: {
        months: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        actual: [912, 948, 965, 988, 952, 971, 998, 1012, 985, 968, 942, 958],
        planned: [905, 920, 935, 950, 940, 955, 970, 985, 975, 960, 945, 950],
      },
      table: {
        columns: ['Month', 'New Hires', 'Planned', 'Variance', 'Time-to-Fill', 'Accept Rate', 'Internal %'],
        rows: [
          ['January', '485', '520', '-35', '44 days', '86%', '12%'],
          ['February', '512', '530', '-18', '43 days', '87%', '13%'],
          ['March', '548', '540', '+8', '41 days', '88%', '14%'],
          ['April', '492', '510', '-18', '42 days', '85%', '11%'],
          ['May', '518', '525', '-7', '44 days', '86%', '12%'],
        ],
      },
    },
  },
  heatmapTitle: 'Voluntary Terminations Vs Headcount',
  heatmapSubtitle: 'Voluntary Attrition Rate By Business Unit By Month',
  chartRowCount: 168,
  heatmapRows: ['Data & AI Platforms', 'Quality Management', 'Customer Success', 'Hardware Engineering', 'Robotics & Automation', 'Finance & Accounting'],
  heatmapMonths: ["Jan'25", "Feb'25", "Mar'25", "Apr'25", "May'25", "Jun'25", "Jul'25", "Aug'25", "Sep'25", "Oct'25", "Nov'25", "Dec'25"],
  heatmapOutlier: { row: 2, col: 3 },
  /** Normalized 0-1: sparse hotspots; most cells near-white; CS Apr navy; QM Sep/Dec dark blue */
  heatmapValues: [
    [0.10, 0.08, 0.12, 0.14, 0.58, 0.11, 0.13, 0.09, 0.15, 0.10, 0.55, 0.09],
    [0.09, 0.10, 0.08, 0.11, 0.09, 0.10, 0.08, 0.18, 0.86, 0.12, 0.16, 0.84],
    [0.32, 0.30, 0.34, 0.96, 0.10, 0.11, 0.52, 0.10, 0.09, 0.10, 0.09, 0.10],
    [0.06, 0.07, 0.14, 0.07, 0.13, 0.06, 0.07, 0.15, 0.07, 0.06, 0.07, 0.06],
    [0.30, 0.09, 0.10, 0.08, 0.09, 0.10, 0.32, 0.09, 0.10, 0.08, 0.09, 0.31],
    [0.07, 0.06, 0.07, 0.16, 0.06, 0.07, 0.06, 0.07, 0.06, 0.15, 0.06, 0.07],
  ],
  lineChartTitle: 'Voluntary Terminations By Month',
  lineChartPoints: [102, 112, 108, 118, 125, 122, 132, 145, 128, 138, 152, 158],
};

/** ~43s tour: delays ms from loop start */
export const SEMHR_TOUR_STEPS = [
  'landing',
  'question',
  'analyzing',
  'intro',
  'observations',
  'chart',
  'table',
  'followups',
  'sql',
  'dash-termination',
  'bookmark-open-headcount',
  'bookmark-pick-headcount',
  'dash-headcount-loading',
  'dash-headcount',
  'bookmark-open-hires',
  'bookmark-pick-hires',
  'dash-hires-loading',
  'dash-hires',
  'dynamic-empty',
  'dynamic-prompt',
  'heatmap',
  'line-edit',
  'line-chart',
];

export const SEMHR_TOUR_DELAYS = [
  0, 900, 1800, 2800, 3800, 5000, 6500, 7800, 9200,
  11200, 12500, 14000, 14800, 16100, 17500, 19000, 20500, 21800, 24000, 26000,
  29000, 32400, 35800,
];

export const SEMHR_TOUR_LOOP_PAUSE = 28000;

/** In-app BI gallery: PBI bookmark flip sequence only (relative ms from loop start). */
export const SEMHR_PBI_GALLERY_STEPS = [
  'dash-termination',
  'bookmark-open-headcount',
  'bookmark-pick-headcount',
  'dash-headcount-loading',
  'dash-headcount',
  'bookmark-open-hires',
  'bookmark-pick-hires',
  'dash-hires-loading',
  'dash-hires',
];

export const SEMHR_PBI_GALLERY_DELAYS = [
  0, 1300, 2800, 3600, 4900, 6300, 7800, 8600, 9900,
];

export const SEMHR_PBI_GALLERY_LOOP_PAUSE = 4200;

/** Conversation section: headcount by business unit (semantichr_chat_only1). */
export const SEMHR_CONVERSATION = {
  question: 'Headcount by business unit',
  analyst:
    'The headcount by business unit shows the number of active employees in each department. The Cloud Services unit has the highest headcount with 4,131 employees, followed closely by Corporate Shared Services with 4,043 employees. Other notable units include Finance & Accounting with 1,948 employees and Supply Chain & Distribution with 1,918 employees. The smallest units in terms of headcount are Data & AI Platforms with 537 employees and Quality Management with 546 employees.',
  chartTitle: 'Business Unit',
  tableTitle: 'Query results',
  columns: ['Business Unit', 'Headcount'],
  rows: [
    ['Cloud Services', '4,131'],
    ['Corporate Shared Services', '4,043'],
    ['Finance & Accounting', '1,948'],
    ['Supply Chain & Distribution', '1,918'],
    ['IT & Security', '1,303'],
    ['Research & Development', '1,217'],
    ['Sales & Commercial Operations', '1,152'],
    ['Robotics & Automation', '908'],
  ],
  footer: 'Show 6 more',
  chartBars: [
    { label: 'Cloud Services', value: 4131 },
    { label: 'Corp Shared Svcs', value: 4043 },
    { label: 'Finance & Acct', value: 1948 },
    { label: 'Supply Chain', value: 1918 },
    { label: 'IT & Security', value: 1303 },
    { label: 'R&D', value: 1217 },
    { label: 'Sales & Commercial', value: 1152 },
    { label: 'Robotics & Auto', value: 908 },
    { label: 'Manufacturing Ops', value: 858 },
    { label: 'Hardware Eng', value: 776 },
    { label: 'Quality Mgmt', value: 546 },
    { label: 'Data & AI', value: 537 },
    { label: 'Intl Operations', value: 457 },
    { label: 'Customer Success', value: 183 },
  ],
};

export const SEMHR_CONVERSATION_STEPS = ['question', 'analyzing', 'intro', 'chart', 'table'];

export const SEMHR_CONVERSATION_DELAYS = [0, 500, 1400, 2200, 3000];

export const SEMHR_CONVERSATION_LOOP_PAUSE = 4200;
